import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopupContent.StepThree',
    {
        bankDetails: 'Bank details',
        address: 'Address',
        misc: 'Miscellaneous',
    }
);
